const accordionFooter = () => {

    if ($(window).width() < 768) {

        var acc = document.getElementsByClassName("accordion");
        var i,y;

        for (i = 0; i < acc.length; i++) {

            acc[i].addEventListener("click", function() {

                if (!(this.classList.contains('active'))) {
                    for (y = 0; y < acc.length; y++) {
                        if (acc[y].classList.contains('active')) {
                            acc[y].click();
                        }
                    };
                }

                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                }

            });

            if (i == 0) {
                acc[i].click();
            };
        }

    }

}

module.exports = {

    accordionFooter

};